// @ts-nocheck
export const env: string = import.meta.env.VITE_APP_ENV ?? 'development'
export const apiHost: string = import.meta.env.VITE_API_HOST ?? 'http://localhost:5010'

// やねプロ メディアサイトの公開オリジン (本番: https://yane.pro / STG: https://stg.yane.pro)。
// 記事の公開ページへのリンク等に使う。ドメインはハードコードせず env で差し込む。
export const mediaSiteOrigin: string =
  import.meta.env.VITE_MEDIA_SITE_ORIGIN ?? 'http://localhost:5014'

export const sentryDns: string = import.meta.env.VITE_SENTRY_DSN ?? ''

// NOTE: env 未設定時のハードコードフォールバックは持たない (空文字 → CustomProvider 側で初期化 skip)。
// 過去は STG 値 'GTM-54JX8ZV6' をデフォルトにしていたが、env 未設定環境で誤って STG コンテナへ
// 計測を飛ばしてしまう事故が起きうるため、company / customer と挙動を揃えた。
// 参考: Issue #1991
export const gtmId: string = import.meta.env.VITE_GTM_ID ?? ''

export const firebaseApiKey: string = import.meta.env.VITE_FIREBASE_API_KEY ?? 'test'
export const firebaseAuthDomain: string = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? 'localhost'
export const firebaseProjectId: string =
  import.meta.env.VITE_FIREBASE_PROJECT_ID ?? 'iesapuri-local'
export const firebaseEmulating: string = import.meta.env.VITE_FIREBASE_EMULATING ?? false
export const firebaseEmulatorHost: string =
  import.meta.env.VITE_FIREBASE_EMULATOR_HOST ?? 'http://127.0.0.1:9099'
